import { makeStyles } from "@fluentui/react-components";
import designTokens from "../../theme/customTheme";

export const useToastStyles = makeStyles({
  toast: {
    width: "fit-content",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    fontSize: designTokens.fontSize.sm,
    textAlign: "center",
    borderRadius: designTokens.borderRadius.md,
    borderTopWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftColor: "transparent",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    maxWidth: "90vw",
    "& > div": {
      width: "100%",
    },
  },
  warning: {
    borderLeftColor: designTokens.semantic.warning,
    borderTopColor: designTokens.semantic.warning,
    borderRightColor: designTokens.semantic.warning,
    borderBottomColor: designTokens.semantic.warning,
    color: designTokens.semantic.warningDark,
    fontWeight: designTokens.fontWeight.normal,
  },
  info: {
    borderLeftColor: designTokens.accent[500],
    borderTopColor: designTokens.accent[500],
    borderRightColor: designTokens.accent[500],
    borderBottomColor: designTokens.accent[500],
    color: designTokens.accent[700],
    fontWeight: designTokens.fontWeight.normal,
  },
  error: {
    borderLeftColor: designTokens.semantic.error,
    borderTopColor: designTokens.semantic.error,
    borderRightColor: designTokens.semantic.error,
    borderBottomColor: designTokens.semantic.error,
    color: designTokens.semantic.error,
    fontWeight: designTokens.fontWeight.normal,
  },
  success: {
    borderLeftColor: designTokens.semantic.success,
    borderTopColor: designTokens.semantic.success,
    borderRightColor: designTokens.semantic.success,
    borderBottomColor: designTokens.semantic.success,
    color: designTokens.semantic.successDark,
    fontWeight: designTokens.fontWeight.normal,
  },
  toaster: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  dismissButton: {
    marginLeft: "auto",
    cursor: "pointer",
    color: designTokens.neutral[900],
    backgroundColor: "transparent",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    borderLeftStyle: "none",
    paddingTop: designTokens.spacing[1],
    paddingBottom: designTokens.spacing[1],
    paddingLeft: designTokens.spacing[1],
    paddingRight: designTokens.spacing[1],
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    transition: `all ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.neutral[700],
    },
    ":active": {
      backgroundColor: designTokens.neutral[200],
    },
    ":focus-visible": {
      outlineWidth: "2px",
      outlineStyle: "solid",
      outlineColor: designTokens.neutral[900],
      outlineOffset: "2px",
      borderRadius: designTokens.borderRadius.sm,
    },
  },
});
